import React, { FC, useRef } from 'react'
import { cn } from '@lib/cn'
import {
  Container,
  OldHeading,
  SliderNavButton,
  Track as UiTrack,
  useSlider,
} from '@components/gassan-ui'

type MembershipSliderTrackProps = {
  itemLength: number
  title: string
  children: React.ReactNode
}

export const MembershipSliderTrack: FC<MembershipSliderTrackProps> = ({
  itemLength,
  title,
  children,
}) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { next, prev, onTouchEnd, canMoveLeft, canMoveRight } = useSlider({ trackRef })

  return (
    <Container>
      <div className="mb-6 flex items-center justify-between lg:mb-8 xxl:mb-10">
        <OldHeading variant="h2" as="h3" mb="0">
          {title}
        </OldHeading>
        <div className={cn('flex', itemLength <= 1 && 'invisible', itemLength > 3 && 'xl:visible')}>
          <SliderNavButton onClick={prev} direction="prev" disabled={!canMoveLeft} />
          <SliderNavButton onClick={next} direction="next" disabled={!canMoveRight} />
        </div>
      </div>
      <UiTrack ref={trackRef} onTouchEnd={onTouchEnd}>
        {children}
      </UiTrack>
    </Container>
  )
}
